import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import DownloadAppBtn from "../../common/DownloadAppBtn";

class VideoVisitComplete extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = Tools.isMobile();
    }

    componentDidMount() {
        logUI('MBHWeb.UI.VideoVisitComplete.ComponentDidMount', new Date(), Tools.getURLPath());
    }

    render() {
        const { myChartRegistrationUrl, isLoggedIn, isFromNonLogin } = this.props;

        return (
            <div className={"container-fluid video-visit-complete-container" + (isLoggedIn ? " body-content" : isFromNonLogin ? " video-visit-complete-margin" : " body-logged-out")}>
                <div className="row">
                    <div className="col-12 col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12 text-center page-content-md">
                                {!isFromNonLogin &&
                                    <div className="row">
                                        <div className="col-12 page-content__top-logo">
                                            <Link to="/login">
                                                <img alt="MyBSWHealth logo" src="/images/mybswhlogo.png" className="img-fluid"
                                                    onClick={() => logUI('MBHWeb.UI.VideoVisitComplete.Logo.Clicked', new Date(), Tools.getURLPath())} />
                                            </Link>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-12">
                                        <h1 className="page-heading">Thanks, your visit is complete!</h1>
                                    </div>
                                </div>
                                <div className="row video-visit-complete__msg">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="video-subheading">
                                                    <h2>Download MyBSWHealth to access your after visit summary.</h2>
                                                    <p>You can also use MyBSWHealth to:</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="mybswh-features-box">
                                                    <ul className="angle-bullets">
                                                        <li>Message your doctor</li>
                                                        <li>Manage appointments</li>
                                                        <li>Order & refill BSW prescriptions</li>
                                                        <li>And more!</li>
                                                    </ul>
                                                </div>
                                                <div className="features-bottom-dividers">
                                                    <div />
                                                    <div />
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row video-visit-complete__app-btns">
                                            <div className="col-12">
                                                <DownloadAppBtn enableDesktopAppIcons />
                                            </div>
                                        </div>
                                        <div className="row video-visit-complete__footer-link">
                                            <div className="col-12">
                                                <a href={myChartRegistrationUrl} target="_blank" onClick={() => logUI('MBHWeb.UI.VideoVisitComplete.CreateAccount.Clicked', new Date(), Tools.getURLPath())}>Set up an account if you need one</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        myChartRegistrationUrl: state.session.serverData ? state.session.serverData.myChartRegistrationUrl : "",
        isLoggedIn: state.domain.li,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoVisitComplete);